/**
 * Cookie consent utilities — EU GDPR + ePrivacy compliance.
 *
 * We only fire "non-essential" scripts (analytics, marketing) *after* the
 * user gives explicit consent for that category. Strictly-necessary cookies
 * (auth, CSRF, session) never need consent because they're required to
 * deliver the service the user requested.
 *
 * Consent record is stored in localStorage under `sll_consent` with a shape:
 *   { v: 1, essential: true, analytics: bool, marketing: bool, at: ISOstring }
 *
 * The record is versioned so a future policy change can force re-consent.
 */

export const CONSENT_KEY = "sll_consent";
export const CONSENT_VERSION = 1;

export function readConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || parsed.v !== CONSENT_VERSION) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeConsent({ analytics = false, marketing = false }) {
  const rec = {
    v: CONSENT_VERSION,
    essential: true,
    analytics: !!analytics,
    marketing: !!marketing,
    at: new Date().toISOString(),
  };
  try { localStorage.setItem(CONSENT_KEY, JSON.stringify(rec)); } catch { /* ignore */ }
  // Broadcast so any listener (banner, analytics loader) can react.
  window.dispatchEvent(new CustomEvent("sll:consent", { detail: rec }));
  return rec;
}

export function clearConsent() {
  try { localStorage.removeItem(CONSENT_KEY); } catch { /* ignore */ }
  window.dispatchEvent(new CustomEvent("sll:consent", { detail: null }));
}

export function acceptAll() {
  return writeConsent({ analytics: true, marketing: true });
}
export function rejectAll() {
  return writeConsent({ analytics: false, marketing: false });
}
